import { makeStyles } from '@material-ui/core/styles';
import { Bogle_Medium, Bogle_Regular } from 'constants/constant';
import { colors } from 'theme/color-palette';
const { WHITE, PURPLE, LIGHT_PURPLE, FONT_COLOR, TOGGLE_ACTIVE, DISABLED } = colors;

const PreviewDialogStyle = makeStyles(() => ({
	container: {
		padding: '16px'
	},
	tittlePadding: {
		padding: '16px 16px 8px 16px'
	},
	contentPadding: {
		padding: '16px'
	},
	actionBtnPadding: {
		padding: '8px 16px 16px 16px'
	},
	button: {
		height: 40,
		textTransform: 'none',
		fontSize: 14,
		marginLeft: '16px !important',
		width: 76,
		borderRadius: 50,
		'&:hover': {
			background: TOGGLE_ACTIVE
		}
	},
	btnDelete: {
		borderRadius: 50,
		background: PURPLE,
		color: WHITE,
		'&:hover': {
			backgroundColor: LIGHT_PURPLE
		}
	},
	buttonLabel: {
		fontSize: '14px',
		fontWeight: 400,
		color: PURPLE,
		fontFamily: Bogle_Medium,
		cursor: 'pointer'
	},
	lblDelete: {
		fontSize: '14px',
		fontWeight: 400,
		color: WHITE,
		fontFamily: Bogle_Medium,
		cursor: 'pointer'
	},
	dialogTitle: {
		fontSize: 22,
		fontFamily: Bogle_Medium,
		color: FONT_COLOR
	},
	dialogContent: {
		fontSize: 16,
		fontFamily: Bogle_Regular,
		color: FONT_COLOR
	},
	radio: {
		margin: '16px 0px 0px 0px'
	},
	radioButton: {
		marginRight: '8px',
		root: {
			color: 'black'
		}
	},
	disabledButton: {
		color: WHITE,
		backgroundColor: DISABLED
	}
}));

export default PreviewDialogStyle;
